import axios from "axios";

export default {
  role: async (token) => {
    const url = process.env.VUE_APP_API + "ref/role";

    const response = await axios.get(url, {
      headers: {
        Authorization: "Bearer " + token,
      },
    });

    return response.data.data;
  },

  Kab: async (token) => {
    const url = process.env.VUE_APP_API + "ref/kabupaten";

    const response = await axios.get(url, {
      headers: {
        Authorization: "Bearer " + token,
      },
    });

    return response.data.data;
  },

  Kec: async (token, kab) => {
    const url = process.env.VUE_APP_API + "ref/kecamatan/" + kab;

    const response = await axios.get(url, {
      headers: {
        Authorization: "Bearer " + token,
      },
    });

    return response.data.data;
  },

  Kel: async (token, kec) => {
    const url = process.env.VUE_APP_API + "ref/kelurahan/" + kec;

    const response = await axios.get(url, {
      headers: {
        Authorization: "Bearer " + token,
      },
    });

    return response.data.data;
  },

  Desa: async (token, kec) => {
    const url = process.env.VUE_APP_API + "ref/desa/" + kec;

    const response = await axios.get(url, {
      headers: {
        Authorization: "Bearer " + token,
      },
    });

    return response.data.data;
  },

  Tps: async (token, kel) => {
    const url = process.env.VUE_APP_API + "ref/tps/" + kel;

    const response = await axios.get(url, {
      headers: {
        Authorization: "Bearer " + token,
      },
    });

    return response.data.data;
  },

  Pekerjaan: async (token) => {
    const url = process.env.VUE_APP_API + "ref/pekerjaan";

    const response = await axios.get(url, {
      headers: {
        Authorization: "Bearer " + token,
      },
    });

    return response.data.data;
  },

  Akkat: async (token) => {
    const url = process.env.VUE_APP_API + "ref/akkat";

    const response = await axios.get(url, {
      headers: {
        Authorization: "Bearer " + token,
      },
    });

    return response.data.data;
  },
};
